import { render, staticRenderFns } from "./OzDrawerStatic.vue?vue&type=template&id=5243e09c&scoped=true&"
import script from "./OzDrawerStatic.vue?vue&type=script&lang=ts&"
export * from "./OzDrawerStatic.vue?vue&type=script&lang=ts&"
import style0 from "./OzDrawerStatic.vue?vue&type=style&index=0&id=5243e09c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5243e09c",
  null
  
)

export default component.exports